export const mfeName = "shell";
export const helpUrl = "https://help.adesa.com/category/adesa-clear/";
